// extracted by mini-css-extract-plugin
export default {"timer":"Test_timer__+7ZZX","timer__minute":"Test_timer__minute__WPhMZ","text":"Test_text__NrmzA"};